<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="isUpdatingIntegration ? 'Update Integration' : 'Add Integration'" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    <tidy-add-integration-form
      [isUpdatingIntegration]="isUpdatingIntegration"
      [isRightSideContent]="isRightSideContent"
      [dialogParams]="dialogParams" />
  </tidy-wrapper>
</ng-template>

@switch (isRightSideContent) {
  @case (true) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
  @case (false) {
    <app-scroll-wrapper [templateContent]="content" />
  }
}
